export const users = [
  {
    id: 1,
    fullname: 'Tristan Izambard',
    role: 'Président',
    username: 'Timz',
    contact: '07 81 40 37 06',
    email: 'tristan.izambard@live.fr',
    status: 'active',
    avatar: 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/img/9.3fd39137.png',
  },
  {
    id: 2,
    fullname: 'Kenan Dufrene',
    role: 'Vice-Président',
    username: 'Anebris',
    contact: '07 81 40 37 06',
    email: 'kenan.dufrene@live.fr',
    status: 'inactive',
    avatar: 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/img/9.3fd39137.png',
  }  
]

export const userData = {
  jwt: 'qddsqdsqdqsdsqzdzdzd',
  firstname: 'Kenan',
  lastname: 'Dufrene',
  role: 'Vice-Président',
  avatar: 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/img/9.3fd39137.png',
}
